import PropTypes from 'prop-types'
import PublicModalDrawer from 'components/PublicModalDrawer'
import { useDispatch, useSelector } from 'react-redux'
import CustomerGetInTouchModal from './getHelp/CustomerGetInTouchModal'
import ApiClient from 'data/api/api_client'
import { useState } from 'react'
import { clearUser } from 'store/auth'
import GetHelpModal from './getHelp/GetHelpModal'
import MainCustomerProfileModalSection from 'components/user/profile/MainCustomerProfileModalSection'
import CustomerProfileSection from 'components/user/profile/CustomerProfileSection'
import { useRouter } from 'next/router'
import { clearInbox } from 'store/inbox'

const CustomerProfilemodal = ({ isOpen = false, onClose = () => { }, contentsIn = 'main' }) => {
  const dispatch = useDispatch()
  const [modalOpen, setModalOpen] = useState(false)
  const [contents, setContents] = useState(contentsIn)
  const router = useRouter()

  const logout = (e) => {
    e.preventDefault()
    ApiClient.auth.logout()
    dispatch(clearUser())
    dispatch(clearInbox())
    onClose()
    router.push('/')
  }

  const { user } = useSelector(state => ({
    user: state.auth.user,
  }))

  const [getHelpModalOpen, setGetHelpModalOpen] = useState(false)
  const [modalType, setModalType] = useState(null)

  const setModal = (type) => {
    setModalType(type)
    setGetHelpModalOpen(true)
  }

  const renderContents = () => {
    switch (contents) {
      case 'profile':
        return (
          <CustomerProfileSection
            user={user}
            setContents={setContents}
          />
        )
      case 'main':
      default:
        return (
          <MainCustomerProfileModalSection
            logout={logout}
            user={user}
            setModal={setModal}
            setModalOpen={setModalOpen}
            setContents={setContents}
          />
        )
    }
  }

  return (
    <PublicModalDrawer isOpen={isOpen} onClose={onClose}>

      {renderContents()}
      <CustomerGetInTouchModal modalOpen={modalOpen} onClose={() => setModalOpen(false)} />
      <GetHelpModal modalOpen={getHelpModalOpen} onClose={() => setGetHelpModalOpen(false)} initialType={modalType} />
    </PublicModalDrawer>
  )
}

CustomerProfilemodal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  contentsIn: PropTypes.string,
}

export default CustomerProfilemodal
